import { useTranslation } from 'react-i18next'

import { BillingAddress } from '@/components/DisplayAddress/BillingAddress'

interface InvoiceAddressProps {
  billingInfo?: {
    names?: string[]
    street?: string
    street4?: string
    houseNumber?: string
    zip?: string
    city?: string
    country?: string
  }
}

const defaultBillingInfo = {
  names: [],
  street: '',
  street4: '',
  houseNumber: '',
  zip: '',
  city: '',
  country: '',
}

const InvoiceAddress = ({
  billingInfo = defaultBillingInfo,
}: InvoiceAddressProps) => {
  const { t } = useTranslation()

  return (
    <div className="profile__main-block mt-5">
      <div className="profile__main-block__label mb-3">
        {t('myProfile.invoiceAddress')}
      </div>
      <BillingAddress data={billingInfo} />
    </div>
  )
}

export default InvoiceAddress
